import { mapGetters } from 'vuex'

export const hasRole = {
  methods: {
    hasRole(role) {
      return this.getUser.roles.data.map(x => x.name).includes(role)
    }
  },
  computed: {
    ...mapGetters([
      'getUser'
    ])
  }
}